<template>
  <div>
    <div class="container-fluid bg-white p-5 colunm-border-bottom">
      <h1 class="text-uppercase font-basetheme font-kanit text-center my-3">PARTNER</h1>
      <div class="row d-flex justify-content-around">
        <img src="@/assets/img/home/partner/wha.png" height="100" class="m-3" alt />
        <img src="@/assets/img/home/partner/scb.png" height="100" class="m-3" alt />
        <img src="@/assets/img/home/partner/samsung.jpeg" height="100" class="m-3" alt />
        <img src="@/assets/img/home/partner/SIS.jpg" height="100" class="m-3" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>